import type { HTMLAttributes, ReactNode, Ref } from "react";

/**
 * Scrollbereich (design/README §4.4, §9.8; oberflaeche.md §1.6, V-25): Liste in einem Rahmen mit Hinweisstreifen in eigener
 * Zeile (O-04). Der Streifen ist ein `button` mit dem zugänglichen Namen „<n> weitere“ bzw. „<n> ältere“ (sichtbar mit Dreieck,
 * das Dreieck ist `aria-hidden`); er verdeckt nichts, blättert beim Antippen um eine sichtbare Höhe weiter und ist verborgen,
 * solange nichts außerhalb liegt (`gestaltung.ts`). Der Bereich füllt seinen Platz und scrollt nativ ohne Einrasten (README §14
 * N11). Ein Verlauf (`auf`) ist unten verankert, der Streifen steht oben. Handlungen einer Ansicht (z. B. „Hinzufügen“) stehen
 * nie im Scrollbereich, sondern fest darunter. `abdruck`: Liste nach einer großen Hauptaktion (Abholliste, Bergeliste; K71, K76),
 * `kopf` steht über der Liste.
 */
export function Scrollbereich({ auf, abdruck, kopf, className, scrollRef, children, ...rest }: {
  auf?: boolean; abdruck?: boolean; kopf?: ReactNode; className?: string; scrollRef?: Ref<HTMLDivElement>; children: ReactNode;
} & Omit<HTMLAttributes<HTMLDivElement>, "className" | "children">) {
  const rahmen = ["scroll-rahmen", auf ? "scroll-rahmen--auf" : null, abdruck ? "scroll-rahmen--abdruck" : null].filter(Boolean).join(" ");
  return (
    <div className={rahmen}>
      {auf ? <button type="button" className="mehr mehr--oben" /> : null}
      {kopf}
      <div ref={scrollRef} className={className ? `scroll ${className}` : "scroll"} data-liste={auf ? "auf" : "ab"} {...rest}>{children}</div>
      {auf ? null : <button type="button" className="mehr" />}
    </div>
  );
}
